import { State } from "../types/store";

export const selectFields = (state: State) => state.fields.list;

export const selectAllFieldsIDs = (state: State) => {
    const allIDs = state.fields.list.map(el => el._id.toString());
    return allIDs;
};

export const selectIsFormHavePromocodeField = (state: State) => state.fields.isHavePromoCodeField;
export const selectIsFormHavePaymentTypeField = (state: State) => state.fields.isHavePaymentTypeField;
